import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import parseNumber from "../../utils/parseCalculate";
import axios from "../../utils/axios";
import { useLiveDevice } from "../../hooks/useLiveDeviceData";
import { DeleteIcon, ReportIcon, WifiIcon } from "../icons/StatusIcons";

const UserDeviceCard = (props) => {
  const isSubscriptionExpired =
    new Date(props?.allData?.subscription_end) <= new Date();
  const { data, units, status } = useLiveDevice(
    isSubscriptionExpired ? null : props.id,
    { watchStatus: true }
  );
  const deviceDetail = {
    data,
    flow_unit: units.flow_unit,
    level_unit: units.level_unit,
    total_unit: units.total_unit,
  };
  const deviceStatus = isSubscriptionExpired ? "inactive" : status;
  const flowRate = data?.flowrate ? parseNumber(data.flowrate) : "";
  const totalFlow = data?.totalizer ? parseNumber(data.totalizer) : "";
  const level = data?.level ? parseNumber(data.level) : "--";

  const handleDeleteDevice = async () => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await axios
            .post("device/delete", {
              deviceId: props.id,
            })
            .then(async () => {
              await Swal.fire({
                title: "Success",
                text: "Device successfully deleted",
                icon: "success",
              });
            });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (props.onStatusUpdate) {
      props.onStatusUpdate(props.id, deviceStatus);
    }
  }, [deviceStatus]);

  return (
    <div className={`detail-listing-wrap user-device-card ${props.className || ""}`}>
      <div className="about-info-wrap item1">
        <Link to={props.link} className="user-name text-uppercase">
          {props.name}
        </Link>
        <p className="subscription-detail">
          Subscription End:{" "}
          {new Date(props?.allData?.subscription_end).toLocaleDateString(
            "en-US",
            {
              year: "numeric",
              month: "short",
              day: "numeric",
            }
          )}
        </p>
      </div>

      <div className="item2 d-flex align-items-center justify-content-lg-between">
        {isSubscriptionExpired ? (
          <div className="flow-info" style={{ width: "100%" }}>
            <h5
              className="assigned-num"
              style={{ color: "#ff4444", fontWeight: "bold" }}
            >
              Subscription Expired
            </h5>
          </div>
        ) : (
          <>
            <div className="flow-info">
              <h5 className="assigned-num">{flowRate ? flowRate : level}</h5>
              <p className="assigned-text">
                {flowRate ? "Current Flow" : "Level"}
              </p>
              {(flowRate ? deviceDetail?.flow_unit : deviceDetail?.level_unit) && (
                <p className="flow-unit">
                  ({flowRate ? deviceDetail.flow_unit : deviceDetail.level_unit})
                </p>
              )}
            </div>

            <div className="total-flow-info">
              {totalFlow && (
                <>
                  <h5 className="assigned-num">{totalFlow}</h5>
                  <p className="assigned-text">Total Flow</p>
                  {deviceDetail?.total_unit && (
                    <p className="flow-unit">({deviceDetail.total_unit})</p>
                  )}
                </>
              )}
            </div>

            {deviceStatus !== "active" && (
              <div className="total-flow-info">
                <p className="fs-6 fw-bold text-danger text-center">
                  {deviceDetail?.data?.date_time
                    ? new Date(deviceDetail.data.date_time)
                        .toLocaleDateString("en-GB")
                        .slice(0, 10)
                    : "--"}
                </p>
                <p className="fs-6 fw-bold text-danger text-center">
                  {deviceDetail?.data?.date_time
                    ? new Date(deviceDetail.data.date_time).toLocaleTimeString(
                        "en-US",
                        {
                          hour12: false,
                        }
                      )
                    : "--"}
                </p>
                <p className="assigned-text">Last Updated</p>
              </div>
            )}
          </>
        )}
      </div>

      <div className="status-icon-row item3">
        <button
          type="button"
          onClick={handleDeleteDevice}
          className="btn-action"
          aria-label="Delete device"
        >
          <DeleteIcon />
        </button>
        <Link
          to={props.reportLink}
          className="btn-action"
          aria-label="Open report"
        >
          <ReportIcon />
        </Link>
        {!isSubscriptionExpired && (
          <WifiIcon connected={deviceStatus === "active"} />
        )}
      </div>
    </div>
  );
};

export default UserDeviceCard;
